// extracted by mini-css-extract-plugin
module.exports = {"heading":"FormHeading_heading__2l8qA"};